import { DrawerActions, useNavigation } from '@react-navigation/native'
import { useCallback } from 'react'

export const useMenu = () => {
  const navigation = useNavigation()

  const openMenu = useCallback(() => {
    navigation.dispatch(DrawerActions.openDrawer())
  }, [navigation])

  const closeMenu = useCallback(() => {
    navigation.dispatch(DrawerActions.closeDrawer())
  }, [navigation])

  return { openMenu, closeMenu }
}
